import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="bg-primary-900">
      {/* Go to top and copyright */}
      <div className="py-6 text-center">
        <button
          onClick={scrollToTop}
          className="flex flex-col items-center gap-1 text-primary-400 hover:text-white transition-colors mx-auto mb-4"
        >
          <i className="ri-arrow-up-s-line text-xl" />
          <span className="text-[10px] tracking-[0.25em] uppercase">GO TO TOP</span>
        </button>
        <p className="text-[10px] text-primary-500 tracking-wide">
          &copy; 2025 by Finest Kind Seafood LLC.
        </p>
      </div>
    </footer>
  );
}